import { createFileRoute } from "@tanstack/react-router";
import { TemplateList } from "@/features/admin-email-templates/TemplateList";
function Page() { const { session } = Route.useRouteContext(); return <TemplateList key={session.user.id} actorId={session.user.id} />; }
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/email-templates/")({ component: Page });
